import {useState, useEffect, useCallback, Fragment} from "react";
import {startOfMonth, endOfMonth,getMonth,setMonth,getYear,setYear,
        endOfYesterday,endOfYear,startOfYear} from "date-fns";

import {MenuItem} from "@mui/material";

import { RadioGroupCustom, SelectCustom } from "../../../components/InputCustom";
import { DialogCustom } from "../../../components/ModalCustom";
import { ButtonConfirmCustom } from "../../../components/ButtonCustom";
import {PERIODS,AVAILABLE_PERIODS,AVAILABLE_MONTHS, AviableYears} from "./settings";

export default function PeriodPicker(props) {
  const {showPeriodPicker,onClose,onConfirm,reportFromDate,
          reportToDate,selectedPeriod,selectedFrequency} = props

  const [from, setFrom] = useState(reportFromDate);
  const [to, setTo] = useState(reportToDate);
  const [period, setPeriod] = useState(selectedPeriod);
  const [freq, setFreq] = useState(selectedFrequency);

  useEffect(() => {
    setFrom(reportFromDate);
    setTo(reportToDate);
    setPeriod(selectedPeriod);
    setFreq(selectedFrequency);
  },[reportFromDate, reportToDate, selectedPeriod, selectedFrequency]);

  useEffect(() => {
    //reset values when modal is closed
    if (!showPeriodPicker) {
      setFrom(reportFromDate);
      setTo(reportToDate);
      setPeriod(selectedPeriod);
      setFreq(selectedFrequency);
    }
  },[reportFromDate, reportToDate, selectedPeriod, selectedFrequency, showPeriodPicker]);

  ///FUNZIONE DI AGGIORNAMENTO DELLE DATE
  const updateDates = (newFrom, newTo, newFreq = freq) => {
    setFrom(newFrom);
    setTo(newTo);
    setFreq(newFreq);
  };

  const onPeriodChange = useCallback((event) => {
    const newPeriod = event.target.value;
    setPeriod(newPeriod);
    if (newPeriod === PERIODS.LAST_MONTH || newPeriod === PERIODS.MONTH) {
      const fromStartOfMonth = startOfMonth(new Date()) > endOfYesterday() ? 
        startOfMonth(endOfYesterday()) : 
        startOfMonth(new Date());
      updateDates(fromStartOfMonth, endOfYesterday(), "24h");

    } else if (newPeriod === PERIODS.ANNUAL) {
      updateDates(startOfYear(reportFromDate), endOfYear(reportToDate), "30d");
    }
    // eslint-disable-next-line
  },[reportFromDate, reportToDate],);

  const onMonthChange = useCallback((event) => {
    const month = event.target.value;
    const newDate = setMonth(to, month);
    updateDates(startOfMonth(newDate), endOfMonth(newDate));
    // eslint-disable-next-line
  },[to]);

  const onYearChange = useCallback((event) => {
    const year = event.target.value;
    const dateWithNewYear = setYear(to, year);
    const newDate = dateWithNewYear > endOfYesterday() ? setMonth(dateWithNewYear, 0) : dateWithNewYear;
    updateDates(startOfMonth(newDate), newDate);
    // eslint-disable-next-line
  },[to]);

  const onYearAnnualChange = useCallback((event) => {
    const year = event.target.value;
    const dateWithNewYear = setYear(to, year);
    updateDates(startOfYear(dateWithNewYear), endOfYear(dateWithNewYear));
    // eslint-disable-next-line
  },[to]);

  const onConfirmChanges = useCallback(() => {
    onConfirm(from, to, period, freq);
  },[from, onConfirm, period, to, freq],);

  const configSelect = {
    Component:SelectCustom,
    configMonth:{
      idBox:"monthPicker",
      labelId:"month-label",
      label:"Mese",
      id:"month",
      value:getMonth(to),
      onChange:onMonthChange,
      children: AVAILABLE_MONTHS.map((month, index) => {
        const disabled = new Date(getYear(to), index) > endOfYesterday();
        return (
        <MenuItem key={month} value={index} disabled={disabled}>{month}</MenuItem>
        )})
    },
    configYear:{
      idBox:"yearPicker",
      labelId:"year-label",
      label:"Anno",
      id:"year",
      value:getYear(to),
      onChange:onYearChange,
      children: AviableYears().map(year => (
        <MenuItem key={year} value={year}>{year}</MenuItem>))
    }
  }

  const configSelectYear = {
    Component:SelectCustom,
    configYear:{
      idBox:"yearPicker2",
      labelId:"year-label",
      label:"Anno",
      id:"year",
      value:getYear(to),
      onChange:onYearAnnualChange,
      children: AviableYears().map(year => (
        <MenuItem key={year} value={year}>{year}</MenuItem>
      ))
    },
  }

  const renderMensile = () => {
    return (
      <Fragment>
        <configSelect.Component {...configSelect.configMonth}/>
        <configSelect.Component {...configSelect.configYear}/>
      </Fragment>
    )
  }

  const renderAnnuale = () => {
    return (
      <configSelectYear.Component {...configSelectYear.configYear}/>
    )
  }

  const renderBody = () => {
    return (
      <Fragment>
        <RadioGroupCustom period={period} onPeriodChange={onPeriodChange} aviablePeriods={AVAILABLE_PERIODS}/>
        {period === PERIODS.MONTH && renderMensile()}
        {period === PERIODS.ANNUAL && renderAnnuale()}
      </Fragment>
    )
  }

  const configButton = {
    Component:ButtonConfirmCustom,
    func:{
      onClickCancel:onClose,
      onClickConfirm:onConfirmChanges,
    }
  }

  return (
    <DialogCustom 
        renderButton={<configButton.Component {...configButton.func}/>} 
        renderBody={renderBody()}
        open={showPeriodPicker}
        onClose={onClose}
        title="Periodo"
    />
  );
}
